export default __webpack_public_path__ + "static/media/doctor@2x.986dcdb0.jpg";